import React from "react";
import "./LpServices.css";
import attestationImg from "./../../../vid_img/LandingPage/services/Attestation.png";
import apostilleImg from "./../../../vid_img/LandingPage/services/Apostille.png";
import meaImg from "./../../../vid_img/LandingPage/services/MEA.png";
import hrdImg from "./../../../vid_img/LandingPage/services/HRD.png";
import pccImg from "./../../../vid_img/LandingPage/services/PCC.png";
import mofaImg from "./../../../vid_img/LandingPage/services/MOFA.png";
import { Link } from "react-router-dom";

const LpServicesMain = () => {
  return (
    <div className="lpServicesMain-container">
      <div className="lpServicesMain-content">
        <div className="lpServicesMain-cover">
          <Link to={"/"}>
            <h3>ATTESTATION </h3>
          </Link>
        </div>
        <img src={attestationImg} alt="attestation Img" />
      </div>
      <div className="lpServicesMain-content">
        <div className="lpServicesMain-cover">
          <Link to={"/"}>
            <h3>APOSTILLE </h3>
          </Link>
        </div>
        <img src={apostilleImg} alt="Apostille" />
      </div>
      <div className="lpServicesMain-content">
        <div className="lpServicesMain-cover">
          <Link to={"/"}>
            <h3>MEA APOSTILLE</h3>
          </Link>
        </div>
        <img src={meaImg} alt="mea Img" />
      </div>
      <div className="lpServicesMain-content">
        <div className="lpServicesMain-cover">
          <Link to={"/"}>
            <h3>STATE HRD ATTESTATION</h3>
          </Link>
        </div>
        <img src={hrdImg} alt="hrd Img" />
      </div>
      <div className="lpServicesMain-content">
        <div className="lpServicesMain-cover">
          <Link to={"/"}>
            <h3>PCC VERIFICATION</h3>
          </Link>
        </div>
        <img src={pccImg} alt="pcc Img" />
      </div>
      <div className="lpServicesMain-content">
        <div className="lpServicesMain-cover">
          <Link to={"/"}>
            <h3>MOFA ATTESTATION</h3>
          </Link>
        </div>
        <img src={mofaImg} alt="mofa Img" />
      </div>
    </div>
  );
};

export default LpServicesMain;
